/**
 * Рантайм-конфигурация портала (`GET /api/config`).
 *
 * Значения, которые фронт не может знать сам: адреса, зависящие от стенда. В
 * бандл они не попадают — SPA собирается один раз и едет во все окружения.
 *
 * Запрос один на всё приложение: промис кешируется в модуле, поэтому несколько
 * компонентов, спросивших конфиг, не устраивают несколько походов на бэкенд.
 */
import { useEffect, useState } from "react";
import { api } from "../api/client";
import type { PortalConfig } from "../api/types";

let pending: Promise<PortalConfig> | null = null;

function load(): Promise<PortalConfig> {
  if (pending === null) {
    pending = api.config().catch((error) => {
      // Неудачу не кешируем: следующий вызов попробует снова.
      pending = null;
      throw error;
    });
  }
  return pending;
}

export function usePortalConfig(): PortalConfig | null {
  const [config, setConfig] = useState<PortalConfig | null>(null);

  useEffect(() => {
    let cancelled = false;
    load()
      .then((value) => {
        if (!cancelled) setConfig(value);
      })
      .catch(() => {
        /* конфиг необязателен — экраны переживают его отсутствие */
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return config;
}
